import { FC } from "react";

import { useBookingsNavigation } from "@ryde/redux";

import { BookingsPanelTopWrapper } from "./bookings.panel.styled";
import { CalendarViewModeSwitch, PanelTopRightBookings } from "./panel-top";

export const BookingsPanelTop: FC = () => {
  const { isCalendarBookingView } = useBookingsNavigation();
  return (
    <BookingsPanelTopWrapper>
      <div
        className="top_grid_settings_line"
        data-e2e="booking-panel-top-grid-settings"
      >
        {isCalendarBookingView && <CalendarViewModeSwitch />}
        <PanelTopRightBookings />
      </div>
    </BookingsPanelTopWrapper>
  );
};
